import React from 'react';
import { useLocation } from 'react-router-dom';
import useUserContext from '~/contexts/user';
import linkHelper from '~/helpers/link';
import Dropdown, { MenuItem } from '../dropdown/dropdown';
import { assertDefined } from '~/helpers/data';
const settings = window.SETTINGS;
const reqFacultyAccessLink = `${settings.accountHref}/i/signup/educator/cs_form`;
const profileLink = `${settings.accountHref}/profile`;
function AccountItem() {
    const { myOpenStaxUser } = useUserContext();
    const mosIsAvailable = !myOpenStaxUser.error;
    return mosIsAvailable ? (React.createElement(MenuItem, { label: "Account Dashboard", url: "/account" })) : (React.createElement(MenuItem, { label: "Account Profile", url: `${settings.accountHref}/profile` }));
}
export default function LoginMenuWithDropdown() {
    const userModel = assertDefined(useUserContext().userModel);
    // updates logoutLink
    useLocation();
    const label = `Hi ${userModel.first_name || userModel.username}`;
    return (React.createElement(Dropdown, { className: "login-menu nav-menu-item rightmost dropdown", label: label, excludeWrapper: true },
        React.createElement(AccountItem, null),
        userModel.instructorEligible && (React.createElement(MenuItem, { label: "Request instructor access", url: reqFacultyAccessLink })),
        userModel.incompleteSignup && (React.createElement(MenuItem, { label: "Complete your profile", url: profileLink })),
        userModel.pendingInstructorAccess && (React.createElement(MenuItem, { label: "Pending instructor access", url: profileLink })),
        userModel.emailUnverified && (React.createElement(MenuItem, { label: "Verify your email address", url: profileLink })),
        React.createElement(MenuItem, { label: "Log out", url: linkHelper.logoutLink(), local: "true" })));
}
